import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface Product {
  id: string;
  name: string;
  tagline: string;
  description: string;
  category: string;
  image: string;
  logo: string;
  website: string;
  pricing_type: string;
  pricing_amount: string;
  rating: number;
  users_count: number;
  tags: string[];
  features: string[];
  status: string;
  submitted_by: string;
  submitted_at: string;
  approved_at: string;
  created_at: string;
  updated_at: string;
}
